// extracted by mini-css-extract-plugin
module.exports = {"hero__heading":"_aG","heroBG":"_aH","hero":"_aI","hero__box":"_aJ","hero__subheading":"_aK","hero__pageLink":"_aL"};